// extracted by mini-css-extract-plugin
module.exports = {"mobile-s":"320px","mobile":"375px","mobile-l":"425px","tablet-s":"580px","tablet":"768px","tablet-l":"1024px","desktop":"1200px","modal":"700"};